/* NA LEIBERL – Wunschliste (ohne App)
   - Herz-Icon im Header (vor dem Einkaufswagerl) mit Anzahl, Link zu /pages/wunschliste
   - Herz-Button neben "In den Warenkorb" auf der Produktseite
   - Seite /pages/wunschliste rendert alle gemerkten Produkte
   Gespeichert wird im Browser des Besuchers (localStorage, Schluessel "nl-wishlist").
   Herz im Linien-Stil der anderen Icons (Klasse nl-icon, Styles in na-leiberl-ui.css).
   Zusaetzlich fuer alle Produktkarten (Startseite, Kollektionen, Suche):
   - "inkl. MwSt." neben/unter dem Preis
   - scharfe Produktbilder: das Theme schaetzt die Bildbreite zu klein (breitere Seite, grosse Wisch-Karten
     am Handy, quadratische Bilder in hochformatigen Karten mit object-fit: cover) -> "sizes" wird auf die
     tatsaechlich sichtbare Bildbreite gesetzt, damit der Browser eine passend grosse Bildversion laedt. */
(function () {
  var KEY = 'nl-wishlist';
  var PAGE_URL = '/pages/wunschliste';
  var HEART_D = 'M12 20.2 4.7 13a4.9 4.9 0 0 1 0-7 4.9 4.9 0 0 1 6.9 0l.4.4.4-.4a4.9 4.9 0 0 1 6.9 0 4.9 4.9 0 0 1 0 7z';
  var HEART = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-heart nl-heart nl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path class="nl-heart__fill" d="' + HEART_D + '"/>' +
    '<path class="nl-heart__outline" d="' + HEART_D + '"/></svg>';

  // ---------- Speicher ----------
  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('nl:wishlist', { detail: list }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  // ---------- Header-Icon (Badge im gleichen Stil wie beim Einkaufswagerl) ----------
  function headerIcon() {
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || document.querySelector('.header__icon--wishlist')) return;
    var a = document.createElement('a');
    a.href = PAGE_URL;
    a.className = 'header__icon header__icon--wishlist link focus-inset';
    a.innerHTML = '<span class="svg-wrapper">' + HEART + '</span>' +
      '<span class="visually-hidden">Wunschliste</span>' +
      '<div class="cart-count-bubble nl-wish-count" hidden><span aria-hidden="true"></span></div>';
    cart.parentNode.insertBefore(a, cart);
    updateCount();
  }
  function updateCount() {
    var n = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('.nl-wish-count'), function (el) {
      var s = el.querySelector('span');
      if (s) s.textContent = n < 100 ? n : '99+';
      el.hidden = n === 0;
    });
    Array.prototype.forEach.call(document.querySelectorAll('.header__icon--wishlist'), function (a) {
      a.classList.toggle('has-items', n > 0);
      a.setAttribute('aria-label', 'Wunschliste (' + n + ')');
    });
  }

  // ---------- Produktseite: Herz neben dem Warenkorb-Button ----------
  function productHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function productButton() {
    var handle = productHandle();
    if (!handle) return;
    var wrap = document.querySelector('.product__info-container .product-form__buttons');
    if (!wrap || wrap.querySelector('.nl-wish-btn')) return;
    wrap.classList.add('nl-has-wish');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nl-wish-btn';
    b.innerHTML = HEART;
    function sync() {
      var on = has(handle);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Von der Wunschliste entfernen' : 'Auf die Wunschliste');
      b.title = on ? 'Auf deiner Wunschliste' : 'Auf die Wunschliste';
    }
    b.addEventListener('click', function () {
      var added = toggle(handle);
      sync();
      if (added) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
    });
    document.addEventListener('nl:wishlist', sync);
    sync();
    wrap.appendChild(b);
  }

  // ---------- Produktkarten: "inkl. MwSt." + scharfe Bilder ----------
  function bilderScharf() {
    Array.prototype.forEach.call(document.querySelectorAll('.card-wrapper .card__media img[srcset]'), function (img) {
      var r = img.getBoundingClientRect();
      if (!r.width) return; // versteckt (z. B. anderer Tab) -> spaeter
      var bw = parseFloat(img.getAttribute('width')) || 1;
      var bh = parseFloat(img.getAttribute('height')) || 1;
      // object-fit: cover streckt das Bild auf die volle Kartenhoehe -> sichtbare Bildbreite ist oft groesser als die Karte
      var w = Math.max(r.width, r.height * bw / bh);
      var soll = Math.ceil(w) + 'px';
      if (img.getAttribute('sizes') !== soll) img.setAttribute('sizes', soll);
    });
  }
  function karten() {
    Array.prototype.forEach.call(document.querySelectorAll('.card-wrapper'), function (card) {
      var preis = card.querySelector('.card-information .price');
      if (preis && !card.querySelector('.nl-card-mwst')) {
        preis.insertAdjacentHTML('afterend', '<span class="nl-card-mwst">inkl. MwSt.</span>');
      }
    });
    bilderScharf();
  }
  // neue/eingeblendete Karten (Filter, Sortierung, Tabs, "Mehr laden") automatisch versorgen
  var kartenTimer = null;
  function kartenSpaeter() {
    clearTimeout(kartenTimer);
    kartenTimer = setTimeout(karten, 150);
  }
  function kartenBeobachten() {
    if (window.MutationObserver) {
      new MutationObserver(kartenSpaeter).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
    window.addEventListener('resize', kartenSpaeter);
    window.addEventListener('load', kartenSpaeter);
  }

  // ---------- Seite /pages/wunschliste ----------
  function money(cents) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderPage() {
    var root = document.getElementById('nl-wishlist');
    if (!root) return;
    var list = read();
    if (!list.length) {
      root.innerHTML = '<div class="nl-wl-empty"><p class="nl-wl-empty__title">Noch nichts gemerkt?</p>' +
        '<p>Klick bei einem Shirt auf das Herz, dann landet es hier.</p>' +
        '<a class="button" href="/collections/all">Alle Shirts ansehen</a></div>';
      return;
    }
    root.innerHTML = '<p class="nl-wl-loading">Wird geladen …</p>';
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);
      if (valid.length !== list.length) write(valid.map(function (p) { return p.handle; }));
      if (!valid.length) { renderPage(); return; }
      root.innerHTML = '<ul class="nl-wl-grid" role="list">' + valid.map(function (p) {
        var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=600' : p.featured_image + '?width=600') : '';
        var onSale = p.compare_at_price && p.compare_at_price > p.price;
        return '<li class="nl-wl-card">' +
          '<a class="nl-wl-card__media" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="nl-wl-card__remove" data-handle="' + esc(p.handle) + '" aria-label="' + esc(p.title) + ' entfernen">×</button>' +
          '<div class="nl-wl-card__body">' +
            '<a class="nl-wl-card__title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
            '<p class="nl-wl-card__price"><span>' + (p.price_varies ? 'ab ' : '') + money(p.price) + '</span>' + (onSale ? '<s>' + money(p.compare_at_price) + '</s>' : '') + '</p>' +
            '<a class="button nl-wl-card__cta" href="/products/' + esc(p.handle) + '">Ansehen</a>' +
          '</div></li>';
      }).join('') + '</ul>';
    });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.nl-wl-card__remove');
    if (!rm) return;
    var list = read().filter(function (h) { return h !== rm.getAttribute('data-handle'); });
    write(list);
    renderPage();
  });

  // ---------- Start ----------
  document.addEventListener('nl:wishlist', updateCount);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { updateCount(); document.dispatchEvent(new CustomEvent('nl:wishlist')); } });
  function init() { headerIcon(); productButton(); renderPage(); karten(); kartenBeobachten(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
